import _extends from "@babel/runtime/helpers/extends";
import React, { useEffect } from 'react';
import { di } from 'react-magnetic-di';
import useAISummaryAction from '../../../../../state/hooks/use-ai-summary-action';
import { AISummariseAction } from './ai-summarise-action';
import { CopySummaryAction } from './copy-summary-action';
export var AISummaryActionComponent = function AISummaryActionComponent(props) {
  var url = props.url,
    onLoadingChange = props.onLoadingChange,
    _props$testId = props.testId,
    testId = _props$testId === void 0 ? 'smart-action-ai-summary-action' : _props$testId;
  var _useAISummaryAction = useAISummaryAction(url),
    _useAISummaryAction$s = _useAISummaryAction.state,
    status = _useAISummaryAction$s.status,
    content = _useAISummaryAction$s.content,
    summariseUrl = _useAISummaryAction.summariseUrl;
  useEffect(function () {
    onLoadingChange === null || onLoadingChange === void 0 || onLoadingChange(status === 'loading');
  }, [onLoadingChange, status]);
  return status === 'done' ? /*#__PURE__*/React.createElement(CopySummaryAction, _extends({}, props, {
    testId: testId,
    content: content
  })) : /*#__PURE__*/React.createElement(AISummariseAction, _extends({}, props, {
    testId: testId,
    summariseUrl: summariseUrl,
    status: status
  }));
};